import React from "react";

import { OptionsType, ResponseType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { AdvancedListRequest } from "types/api/commons";
import { DocumentBody, DocumentDetails, DocumentListItem } from "types/api/document";

function useDocumentApi() {
    const { get, del, post, put } = useHttpManaged();

    const getAllDocuments = React.useCallback(
        (queryParams: AdvancedListRequest, options?: OptionsType): ResponseType<ListResponse<DocumentListItem>> => {
            return get<undefined, AdvancedListRequest, ListResponse<DocumentListItem>>({
                url: "/cm-document",
                queryParams: queryParams,
                options: options,
            });
        },
        [get],
    );

    const getOneDocument = React.useCallback(
        (pathParams: PathParamsWithId, options?: OptionsType): ResponseType<DocumentDetails> => {
            return get<PathParamsWithId, undefined, DocumentDetails>({
                url: "/cm-document/:id",
                pathParams: pathParams,
                options: options,
            });
        },
        [get],
    );

    const createDocument = React.useCallback(
        (body: DocumentBody, options?: OptionsType): ResponseType<ResponseWithId> => {
            return post<undefined, undefined, DocumentBody, ResponseWithId>({
                url: "/cm-document",
                body: body,
                options: options,
            });
        },
        [post],
    );

    const updateDocument = React.useCallback(
        (pathParams: PathParamsWithId, body: DocumentBody, options?: OptionsType): ResponseType<null> => {
            return put<PathParamsWithId, undefined, DocumentBody, null>({
                url: "/cm-document/:id",
                pathParams: pathParams,
                body: body,
                options: options,
            });
        },
        [put],
    );

    const deleteDocument = React.useCallback(
        (pathParams: PathParamsWithId, options?: OptionsType): ResponseType<null> => {
            return del<PathParamsWithId, undefined, null>({
                url: "/cm-document/:id",
                pathParams: pathParams,
                options: options,
            });
        },
        [del],
    );

    return {
        getAllDocuments,
        getOneDocument,
        createDocument,
        updateDocument,
        deleteDocument,
    };
}

export default useDocumentApi;
